module.exports = {"510704001":"涪江街道","510704003":"富乐街道","510704004":"游仙街道","510704006":"四川省科学城春雷街道","510704101":"石马镇","510704102":"新桥镇","510704104":"魏城镇","510704105":"沉抗镇","510704106":"忠兴镇","510704112":"松垭镇","510704121":"小枧镇","510704122":"信义镇","510704123":"仙鹤镇","510704124":"盐泉镇","510704400":"四川省新华劳动教育管理所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510704.json
// module id = 2431
// module chunks = 0